var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-rating',{attrs:{"empty-icon":"mdi-star-outline","full-icon":"mdi-star","hover":"","value":_vm.value,"length":_vm.length,"readonly":"","color":"yellow darken-3","background-color":"grey darken-1"}})
}
var staticRenderFns = []

export { render, staticRenderFns }